import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import Icon from "components/Icon";
import { iconTypes } from "components/Icon/types";
import { noop } from "lodash-es";

const Menu = ({ items, maxHeight, classNames }) => {
    if (!Array.isArray(items) || items.length === 0) {
        return null;
    }

    const style = typeof maxHeight === "number" ? { maxHeight } : {};

    return (
        <div className={cn("menu", classNames.container)} style={style}>
            <ul className={cn("menu__list", classNames.list)}>
                {items.map((item, index) => {
                    const { icon, content, customRender, onClick } = item;

                    if (typeof customRender === "function") {
                        return customRender();
                    }

                    return (
                        <li
                            className={cn("menu__item", classNames.item)}
                            key={`menu-item-${index}`}
                            onClick={() => {
                                onClick ? onClick(item) : noop;
                            }}
                        >
                            {icon && (
                                <span className="icon-container icon-container_s-20 mr-15">
                                    <Icon
                                        type={icon.type}
                                        inheritColor={icon.inheritColor}
                                        inheritSize={icon.inheritSize}
                                    />
                                </span>
                            )}
                            {typeof content === "function"
                                ? content()
                                : content}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

Menu.defaultProps = {
    classNames: {},
};

Menu.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({
                type: iconTypes,
                inheritColor: PropTypes.bool,
                inheritSize: PropTypes.bool,
            }),
            onClick: PropTypes.func,
            content: PropTypes.any,
            customRender: PropTypes.func,
        })
    ),
    maxHeight: PropTypes.number,
    classNames: PropTypes.shape({
        container: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        list: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }),
};

export default Menu;
